const state = {
 reload_company_services: false,
};

const actions = {};

const mutations = {
 RELOAD_COMPANY_SERVICES(state, payload) {
  state.reload_company_services = payload.action;
 }
};

export default {
 state,
 actions,
 mutations
}
